import React, { FC, useEffect, useState } from "react";

import { useTranslation } from "react-i18next";
import pubSub, { EVENTS } from "../../config/pubSub";
import { Snackbar, Alert } from "@mui/material";

const SuccessComponent: FC =  (props) => {
  const [message, setMessage] = useState<any>();
  const [open, setOpen] = React.useState(true);
  const { t } = useTranslation();

  const handleClose = () => {
    setOpen(false);
    setMessage(null);
  };

  useEffect(() => {
    pubSub.subscribe(EVENTS.SUCCESS, (message: any) => {
      setMessage(message);
      if (message) {
        setOpen(true);
      } else {
        setOpen(false);
      }
    });    
  }, []);

  return (
    <>
      {message ? (
        <Snackbar
          open={open}
          anchorOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          autoHideDuration={6000}
          onClose={handleClose}
        >
          <Alert
            severity="success"
            elevation={6}
            variant="filled"
            onClose={handleClose}
          >
            {message}
          </Alert>
        </Snackbar>
      ) : null}
    </>
  );
};

export default SuccessComponent;
